<template>
  <b-container fluid style="padding-right: 0; background: #242424">
    <b-row align-v="center" class="header" no-gutters>
      <b-col cols="8">
        <div class="preOrder-button" @click="confirmation()">
          <img class="preOrder-button-qr" src="@/assets/images/icn_qr.svg" alt="" />
          <div class="preOrder-button-kakutei">
            {{ $t('preOrder.pre-orderConfirm') }}<br />
            <span>{{ $t('preOrder.pleaseReadTheQrCodeAfterTheGuidance') }}</span>
          </div>
        </div>
      </b-col>
      <b-col cols="2">
        <div class="reservation-button" @click="checkReservationStatus">
          <div>
            <img class="preOrder-button-reserve" src="@/assets/images/icn_reserve.svg" alt="" />
            <span>{{ $t('preOrder.appointmentNumber') }}</span>
          </div>
        </div>
      </b-col>
      <b-col class="hamburger" cols="2">
        <div @click="setIsSideMenuOpen(true)">
          <div class="HamburgerMenu"></div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions({
      setIsSideMenuOpen: 'setting/setIsSideMenuOpen',
    }),
    /**
     * 事前注文確定処理
     * カメラ画面起動（QRコードスキャナー画面）
     */
    confirmation() {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/smartphone_order_qrcode_reader`
    },
    checkReservationStatus() {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/get_reservation_info`
      this.$store.commit('modal/setShowingReserveInfoModal', true)
    },
  },
}
</script>
<style lang="scss" scoped>
.preOrder-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  margin-right: 10px;
  background-color: #d21b24;
  border-bottom: 2px solid #96131a;
  border-radius: 5px;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  &-qr {
    width: 30px;
    min-width: 30px;
    max-height: 30px;
    padding: 5px;
    box-sizing: border-box;
  }
  &-kakutei {
    font-weight: bold;
    box-sizing: border-box;
    font-size: 0.8rem;
    padding-top: 4px;
    line-height: 1.05;
    span {
      white-space: nowrap;
      font-size: 0.5rem;
    }
  }
  &-reserve {
    padding-top: 3px;
    width: 20px;
  }
}
.reservation-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  padding-top: 3px;
  background-color: #e6e6e6;
  border-bottom: 2px solid #bfbfbf;
  border-radius: 5px;
  overflow: hidden;
  color: #222;
  font-size: 0.55rem;
  font-weight: bold;

  & span {
    display: block;
  }
}
.header {
  background-color: #242424;
  > div {
    color: #fff;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .hamburger {
    padding: 0;
    div {
      height: 35px;
      @media (max-width: 576px) {
        padding: 0;
      }
      .HamburgerMenu {
        margin-top: 17px;
        position: relative;
        display: block;
        content: 'aa';
        height: 2px;
        width: 25px;
        background-color: #fff;
      }
      .HamburgerMenu::before {
        content: '';
        display: block;
        position: absolute;
        height: 2px;
        width: 25px;
        background-color: #fff;
        top: 7px;
        left: 0;
      }
      .HamburgerMenu::after {
        content: '';
        display: block;
        position: absolute;
        height: 2px;
        width: 25px;
        background-color: #fff;
        top: -7px;
        left: 0;
      }
    }
  }
}
.addBorder::after {
  position: absolute;
  content: '';
  top: 12;
  right: 0;
  height: 30px;
  width: 1px;
  background-color: #414141;
}
</style>
